import type { Response } from 'api';
import { echossAxios } from 'api';

export type BrandTabLinkType = 'internal' | 'loyalty_card' | 'external';
export type BrandTabOpenMethod = 'line_webview' | 'external_browser';

export interface BrandTabConfigItem {
  id: number | null;
  tab_type: 'system' | 'custom';
  system_key: string | null;
  display_name: string | null;
  icon_url: string | null;
  link_type: BrandTabLinkType;
  internal_target: string | null;
  loyalty_card_id: number | null;
  external_url: string | null;
  open_method: BrandTabOpenMethod | null;
}

export interface BrandTabConfig {
  menu_color: string | null;
  version: string | null;
  tabs: BrandTabConfigItem[];
}

interface BrandTabConfigResponse {
  data: BrandTabConfig;
}

export const getBrandTabConfig = async (
  identifier: string,
): Promise<Response<BrandTabConfig>> => {
  try {
    const { data } = await echossAxios.request<BrandTabConfigResponse>({
      url: `/api/member/brands/${encodeURIComponent(identifier)}/tabs`,
      method: 'GET',
      timeout: 5000,
    });

    return { data: data.data };
  } catch (error) {
    return {
      error: error as Response<BrandTabConfig>['error'],
      data: undefined,
    };
  }
};
